import { render, staticRenderFns } from "./product-mb.vue?vue&type=template&id=0f408300&scoped=true&"
import script from "./product-mb.vue?vue&type=script&lang=js&"
export * from "./product-mb.vue?vue&type=script&lang=js&"
import style0 from "./product-mb.vue?vue&type=style&index=0&id=0f408300&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f408300",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Imglazy: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/Imglazy.vue').default,LinkTo: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/LinkTo.vue').default})
